import { getRequest } from '../api-handler';
import { ParameterGroupDetailDto } from './parametergroup';

export const ParameterGroupApi = {
  getById: (id: number) =>
    getRequest<ParameterGroupDetailDto>(`/parametergroups/${id}`)
};
